import { motion } from "framer-motion"
import PropTypes from "prop-types"
import styled from "styled-components"

import BodyCell from "./BodyCell"
import RowReplacementInfo from "./RowReplacementInfo"

const Tr = styled.div`
  width: 100%;
  min-width: ${({ $contentWidth }) => $contentWidth}px !important;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[300]};
  background: ${({ theme }) => theme.colors.baseWhite};

  &.tr--has-replacement-info {
    border-bottom: none;
  }
`

const Row = ({
  row,
  viewportWidth,
  contentWidth,
  availableZipOptionsFormData,
  isHighlightedFromSearch,
  resetScroll,
  rowNumberVal,
}) => {
  const hasReplacementInfo = row?.original?.state?.replacementFor || row?.original?.state?.replacedBy
  const isEven = !!(row.index % 2)
  return (
    <>
      <Tr
        as={motion.div}
        // key is needed here for the motion animation
        key={row.original.articleCode}
        className={hasReplacementInfo && "tr--has-replacement-info"}
        {...row.getRowProps({
          initial: { opacity: 0, maxHeight: 0 },
          animate: { opacity: 1, maxHeight: 150 },
          exit: { opacity: 0, maxHeight: 0 },
          layout: true,
        })}
        $contentWidth={contentWidth}
        $viewportWidth={viewportWidth}
      >
        {row.cells.map((cell, j) => {
          return (
            <BodyCell
              key={cell.column.id}
              cell={cell}
              row={row}
              isArticleCodeCell={j === 0}
              availableZipOptionsFormData={availableZipOptionsFormData}
              isHighlightedFromSearch={isHighlightedFromSearch}
              resetScroll={resetScroll}
              rowNumberVal={rowNumberVal}
            />
          )
        })}
      </Tr>
      {hasReplacementInfo && (
        //if there is a replacementFor information, create an empty row to display it over
        <RowReplacementInfo isEven={isEven} contentWidth={contentWidth} viewportWidth={viewportWidth} row={row} />
      )}
    </>
  )
}

Row.propTypes = {
  row: PropTypes.object,
  contentWidth: PropTypes.number,
  viewportWidth: PropTypes.number,
  availableZipOptionsFormData: PropTypes.shape({
    dxf: PropTypes.bool,
    dwg: PropTypes.bool,
    dxf_3D: PropTypes.bool,
    dwg_3D: PropTypes.bool,
    iges_3D: PropTypes.bool,
    step_3D: PropTypes.bool,
    sat_3D: PropTypes.bool,
  }),
  isHighlightedFromSearch: PropTypes.bool,
  resetScroll: PropTypes.func,
  rowNumberVal: PropTypes.number,
}

export default Row
